// extracted by mini-css-extract-plugin
export default {"MainCont":"Packaging_MainCont__y0KfG","LeftCont":"Packaging_LeftCont__TfWMn","RightCont":"Packaging_RightCont__4etoK"};